// extracted by mini-css-extract-plugin
export default {"contCard":"Card_contCard__iHUWB","img":"Card_img__itDuD","name":"Card_name__xnnft","types":"Card_types__Cn93z"};